import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import store from "./store"
import router from "./router"
import i18n from "./i18n";

Vue.config.productionTip = false;

try {
  axios
    .get("https://accountapi.mobox.io/app/ip/cn")
    .then((res) => {
      if (res.data?.data.isCn) {
        window.location.href = "https://mobox.io/annoucement.html";
      }
    })
    .catch((_) => {
      console.log(_);
    });
} catch (_) {
  console.log(_);
}

new Vue({
  store,
  router,
  i18n,
  data: {
    eventHub: new Vue(),
  },
  render: h => h(App),
}).$mount('#app')
